import React, { useEffect, useState } from 'react';
import { func, object } from 'prop-types';
import styled from 'styled-components';

import { QuestionBody } from 'apps/journey/components/user-profile-setup/components/user-profile-setup-modal/components/styled-question';
import Input from 'library/components/form-components/input';
import { resolve } from 'library/helpers/path-resolver';

const StyledLastFour = styled.div`
  max-width: 200px;
  margin: auto;
`;

const LastFour = ({ answer, handleChange, question }) => {
  const [storedAnswer, setStoredAnswer] = useState();

  useEffect(() => {
    setStoredAnswer(resolve(answer, 'four_digits', ''));
  }, [question.id]);

  return (
    <QuestionBody question={question}>
      <StyledLastFour>
        <Input
          required
          key="four_digits"
          name="four_digits"
          ariaLabel={question.text}
          label="Last 4 Digits"
          type="text"
          pattern="[0-9]{4}"
          onChange={handleChange}
          value={storedAnswer}
        />
      </StyledLastFour>
    </QuestionBody>
  );
};

LastFour.propTypes = {
  answer: object,
  question: object,
  handleChange: func,
};

export default LastFour;
